import { toLayerCapabilitiesURL, getLayerWFSCapabilities } from '../catalog/utils/WFSUtils';
import get from 'lodash-es/get';
import pick from 'lodash-es/pick';
import toPairs from 'lodash-es/toPairs';

import {
    LAYERDOWNLOAD_FORMAT_OPTIONS_FETCH,
    LAYERDOWNLOAD_FORMAT_OPTIONS_UPDATE,
} from './LayerDownloadActions';

const DOWNLOAD_FORMATS_LOOKUP = {
    "gml3": "GML3.1",
    "GML2": "GML2",
    "DXF-ZIP": "DXF-ZIP",
    "application/vnd.google-earth.kml+xml": "KML",
    "OGR-CSV": "OGR-CSV",
    "OGR-FileGDB": "OGR-GeoDatabase",
    "OGR-GPKG": "OGR-GeoPackage",
    "OGR-KML": "OGR-KML",
    "OGR-MIF": "OGR-MIF",
    "OGR-TAB": "OGR-TAB",
    "SHAPE-ZIP": "Shapefile",
    "gml32": "GML3.2",
    "application/json": "GeoJSON",
    "json": "GeoJSON",
    "csv": "CSV",
    "application/x-gpkg": "GeoPackage",
    "excel": "excel",
    "excel2007": "excel2007"
};

export default {
    data() {
        return {
            
        }
    },
    methods: {
        dispatchLayerDownloadAction(params){
            this.$store.dispatch('layerDownloadAction', params);
        },
        onFormatOptionsFetch(layer) {
            this.fetchFormatsWFSDownload(layer);
            this.dispatchLayerDownloadAction({
                type: LAYERDOWNLOAD_FORMAT_OPTIONS_FETCH,
                layer
            });
        },
        updateFormats(wfsFormats) {
            this.wfsFormats = wfsFormats;
            this.dispatchLayerDownloadAction({
                type: LAYERDOWNLOAD_FORMAT_OPTIONS_UPDATE,
                wfsFormats
            });
        },
        fetchFormatsWFSDownload(layer) {
            return getLayerWFSCapabilities(layer).then(data => {
                this.updateFormats(this.hasOutputFormat(data));
            });
        },
        hasOutputFormat(data) {
            const operation = get(data, "WFS_Capabilities.OperationsMetadata.Operation");
            const getFeature = operation.find(o => { return o.name === 'GetFeature'; });
            const parameter = get(getFeature, "Parameter");
            const outputFormatValue = parameter.find(o => { return o.name === 'outputFormat'; }).Value;
            const pickedObj = pick(DOWNLOAD_FORMATS_LOOKUP, outputFormatValue);
            return toPairs(pickedObj).map(([prop, value]) => ({ name: prop, label: value }));
        },
    },
}